import * as LottiePlayer from "@lottiefiles/lottie-player";
import LocationUtil from "../common/utils/LocationUtil";
import { EventEmitter } from "../common/utils/EventEmitter";

class Loading extends EventEmitter {
  // ---------------------------------------------------------------------------
  // --	Loading
  // ---------------------------------------------------------------------------

  constructor() {
    super();

    //スクロール禁止
    document.body.style.overflowY = "hidden";

    //ロゴアニメーションを読み込んでスタートする
    this.player = document.querySelector(".js-lottie-logo");
    this.player.load("/assets/img/common/logo.json");
    this.player.addEventListener("ready", () => {
      this.start();
    });
  }

  /**
   * スタート
   */
  start() {
    if (LocationUtil.getParam("debug")) {
      this.onComplete();
      return;
    } else {
      gsap.to(window, { duration: 0.1, scrollTo: 0 });
      this.play();
    }
  }

  /**
   * ロゴアニメーション
   */
  play() {
    this.player.play();
    gsap.delayedCall(2.4, this.finish.bind(this));
  }

  /**
   * 終了
   */
  finish() {
    //ロゴフェードアウト
    const $logo = document.querySelector(".c-loading__logo");
    gsap.to($logo, {
      duration: 0.6,
      opacity: 0,
      ease: "power0",
    });

    //カバー開く
    const $cover = document.querySelector(".c-loading__cover");
    gsap.to($cover, {
      duration: 0.8,
      delay: 0.5,
      top: "-100%",
      ease: "power2.inOut",
    });

    //コンテンツの動き
    const $header = document.querySelector("#global_header");
    gsap.set($header, {
      y: 200,
    });
    gsap.to($header, {
      y: 0,
      duration: 1.0,
      delay: 0.5,
      ease: "power2.inOut",
    });
    const $main = document.querySelector(".p-main");
    gsap.set($main, {
      y: 200,
    });
    gsap.to($main, {
      y: 0,
      duration: 1.0,
      delay: 0.5,
      ease: "power2.inOut",
      onComplete: this.onComplete.bind(this),
    });
  }

  /**
   * 完了
   */
  onComplete() {
    //スクロール再開
    document.body.style.overflowY = "auto";
    document.querySelector("#global_header").removeAttribute("style");
    document.querySelector(".p-main").removeAttribute("style");
    document.querySelector(".c-loading").remove();
    document.querySelector(".c-loading__base").remove();
    this.emit("COMPLETE");
  }

  // ---------------------------------------------------------------------------
}

export default Loading;
